import axios from "axios";

/**
 * Serviço da página do link de pagamento (/payment-link/{code}).
 * O endpoint é público (sem API Key) e vive sob /api/v2 — que NÃO segue o padrão
 * {Controller}/{Action} do resto do front —, por isso montamos a URL manualmente
 * sobre VUE_APP_API_URL.
 */
export default class PaymentLinkService {
  getLink(code) {
    // A rota /api/v2 é relativa à ORIGEM da API. O VUE_APP_API_URL pode terminar em "/api"
    // (ex.: https://api.../api), então usamos a origem para não duplicar o segmento
    // (https://api.../api/api/v2/... -> 404).
    const apiUrl = process.env.VUE_APP_API_URL || "";
    let origin;
    try {
      origin = new URL(apiUrl).origin;
    } catch (e) {
      origin = apiUrl.replace(/\/+$/, "").replace(/\/api$/, "");
    }
    // Sem cache: a disponibilidade do link muda no servidor (single-use → 410 Gone, que é
    // cacheável por padrão no HTTP). O param _ts + headers no-cache garantem estado fresco a
    // cada abertura, evitando mostrar "indisponível" (ou o contrário) por resposta cacheada.
    return axios
      .get(`${origin}/api/v2/payment-links/${code}`, {
        params: { _ts: Date.now() },
        headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
      })
      .then((r) => r.data.data);
  }
}
